import { render, staticRenderFns } from "./select-icon.vue?vue&type=template&id=a0bfdcb8&scoped=true"
import script from "./select-icon.vue?vue&type=script&lang=js"
export * from "./select-icon.vue?vue&type=script&lang=js"
import style0 from "./select-icon.vue?vue&type=style&index=0&id=a0bfdcb8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0bfdcb8",
  null
  
)

export default component.exports